import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { RedactedPlaceholderComponentShadow } from './RedactedPlaceholderComponentShadow.tsx';

export const RedactedPlaceholderExtensionHandler = LoadableAfterPaint({
	loader: async () => {
		const { RedactedPlaceholder } = await import(
			/* webpackChunkName: "loadable-RedactedPlaceholder" */ './RedactedPlaceholder.tsx'
		);
		return RedactedPlaceholder;
	},
	loading: () => <RedactedPlaceholderComponentShadow />,
});
